import { render, staticRenderFns } from "./AuthorizationCallback.vue?vue&type=template&id=fd7db48e"
import script from "./AuthorizationCallback.vue?vue&type=script&lang=js"
export * from "./AuthorizationCallback.vue?vue&type=script&lang=js"
import style0 from "./AuthorizationCallback.vue?vue&type=style&index=0&id=fd7db48e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports